module.exports = __webpack_public_path__ + "static/media/PerMedCoE.2b28bd09.jpg";